const host = window.location.hostname; 
const tld = host.split('.').pop();     

let baseUrl = 'https://lfpsc4ch.www.printos.com'; // default
if (tld === 'cn') {
  baseUrl = 'https://lfpsc4ch.www.printos.cn';
}

export const environment = {
  production: true,
  baseUrl,
  agmkey: 'AGMKEY',
  ga_code: 'UA-69196706-1',
  redirectURL: 'https://www.printos.com',
  redirectTo_CN_URL: 'https://www.printos.cn',
  maintainanceURL: 'https://hpgraphicspartners.www.printos.com',
  showWhiteList: false,
  gtag_code : '',
  hotjarId : 3405278
};
